import { useNavigate } from "react-router";
import { SidebarNav } from "@atlas-int/ui";

interface SidebarProps {
  activeHeadingId: string | undefined;
  items: { id: string; label: string }[];
}

const Sidebar = ({ activeHeadingId, items }: SidebarProps) => {
  const navigate = useNavigate();

  return (
    <SidebarNav
      activeItemId={activeHeadingId}
      items={items}
      onItemClick={(id) => {
        navigate(`#${id}`, { replace: true });
      }}
    />
  );
};

export default Sidebar;
